module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kc-Lc.02870bc1.png";